export default __webpack_public_path__ + "25bd1e4c162d8670cc9c6a6d8774d13a.png";